import moment from 'moment';

export function isRequired(value) {
  const error = 'required';

  return (!value || String(value).trim().length === 0) ? error : null;
}

export function isEmail(value) {
  const error = 'invalid';
  const regex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i;

  return (value && !value.match(regex)) ? error : null;
}

export function isDateTime(value) {
  const error = 'invalid';

  return (value && !moment(value, 'DD.MM.YYYY H:mm').isValid()) ? error : null;
}



// WEBPACK FOOTER //
// ./src/common/validators.js